import * as React from 'react';
import ResendActivationForm from 'components/UserManagement/ResendActivationForm';

export interface Props {
  children?: React.ReactNode;
}

export interface State {}

export default class ResendActivationPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {};
  }

  render() {
      return <ResendActivationForm />;
  }
}
